import { COLORS } from '@btime/constants'
import React from 'react'

import { IconCountColumn } from '../../../../../components/tables/Table'
import { useOpenNonComplianceModal } from '../../../../../utils/routes/modals/modalsActions'

export const useActionPlansCountColoringColumn = (value, record) => {
  const openNonComplianceModal = useOpenNonComplianceModal()
  const color = record.actionPlansCount && record.actionPlansCount === record.finishedActionPlansCount && COLORS.green

  return (
    <IconCountColumn
      icon="BsListTask"
      onClick={() => openNonComplianceModal(record)}
      value={value || 0}
      record={record}
      color={color}
    />
  )
}
